module.exports = __webpack_public_path__ + "img/logo_cn.1daffbd6.png";